import { render, staticRenderFns } from "./EventTransferInfo.vue?vue&type=template&id=aac0c9d6&"
import script from "./EventTransferInfo.vue?vue&type=script&lang=js&"
export * from "./EventTransferInfo.vue?vue&type=script&lang=js&"
import style0 from "./EventTransferInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports